import React from 'react'
import {Typography} from '@mui/material'
import {makeStyles} from '@mui/styles'
import {spaceLarge, spaceSmall, spaceMedium} from '../../assets/styles/spacing'
import {
  rxrBlackColor,
  rxrDarkGreyColor,
  rxrMediumGreyColor,
  rxrMediumLightGreyColor,
  rxrWhiteColor,
  rxrGreenColor,
  rxrRedColor,
  rxrYellowColor,
} from '../../assets/styles/color'
import {
  fontSizeExtraLarge,
  fontSizeLarge,
  fontSizeMedium,
  heavyFontWeight,
  lightFontWeight,
  mediumFontWeight,
} from '../../assets/styles/typography'
import {getChangeStyle} from './utils'
import PropTypes from 'prop-types'
import ArcChart from './ArcChart'
import DataComingSoon from '../DataComingSoon'

const useStyles = makeStyles(theme => ({
  cardTitle: {
    fontSize: fontSizeLarge,
    fontWeight: heavyFontWeight,
    alignSelf: 'flex-start',
  },

  cardSmall: {
    minWidth: '240x',
    height: '140px',
    borderRadius: '10px',
    border: `1px solid ${rxrMediumLightGreyColor}`,
    background: rxrWhiteColor,
    padding: spaceSmall,
    display: 'flex',
    flexDirection: 'column',
  },

  smallCardColumnContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexGrow: 1,
  },
  leftColumn: {
    color: rxrBlackColor,
    fontSize: fontSizeExtraLarge,
    fontWeight: mediumFontWeight,
    paddingRight: spaceLarge,

    '& span': {
      color: rxrMediumGreyColor,
    },
  },

  chartContainer: {
    padding: spaceSmall,
  },

  changeContainer: {
    flex: 1,
    marginLeft: spaceMedium,
    alignItems: 'center',
    justifyContent: 'flex-start',
    fontSize: fontSizeMedium,
    fontWeight: lightFontWeight,
    color: rxrDarkGreyColor,
  },

  inherit: {
    fontSize: 'inherit',
    fontWeight: 'inherit',
    color: 'inherit',
  },
}))

const DEFAULT_DENOMINATOR = 1

function SentimentCard(props) {
  const classes = useStyles()
  const changeStyle = getChangeStyle(props.change)

  const title = props.title
  const value = props.value
  const change = props.change
  const changeDescription = props.changeDescription
  const denominator = isNaN(props.denominator) ? DEFAULT_DENOMINATOR : props.denominator

  const ratio = value / denominator
  const arcColor = ratio < 0.3 ? rxrRedColor : ratio < 0.7 ? rxrYellowColor : rxrGreenColor
  const showEmptyState = !value || value === 'N/A'
  return (
    <div className={classes.cardSmall}>
      <Typography className={classes.cardTitle}>{title}</Typography>
      {showEmptyState ? (
        <DataComingSoon />
      ) : (
        <div className={classes.smallCardColumnContainer}>
          <div className={classes.chartContainer}>
            <ArcChart maxVal={1} width={80} minVal={-1} score={value} arcDegrees={180} arcColor={arcColor} />
          </div>
          <div className={classes.changeContainer}>
            <Typography className={classes.inherit} style={{color: changeStyle.color}}>
              {changeStyle.sign}
              {change}
            </Typography>
            <Typography className={classes.inherit}>{changeDescription}</Typography>
          </div>
        </div>
      )}
    </div>
  )
}

SentimentCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  denominator: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  change: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  changeDescription: PropTypes.string.isRequired,
}

export default SentimentCard
